import {
    USER_LOGIN_REQUEST,
    USER_LOGIN_SUCCESS,
    USER_LOGIN_FAILURE,
    USER_LOGIN_FAILURE_TESTING,
    USER_LOGIN_2FA_REQUIRED,
    USER_REGISTER_REQUEST,
    USER_REGISTER_SUCCESS,
    USER_REGISTER_FAILURE,
    USER_ROLES_REQUEST,
    USER_ROLES_SUCCESS,
    USER_ROLES_FAILURE,
    USERS_BY_ROLES_REQUEST,
    USERS_BY_ROLES_SUCCESS,
    USERS_BY_ROLES_FAILURE,
    FETCH_ALL_REGISTERD_USERS_REQUEST,
    FETCH_ALL_REGISTERD_USERS_SUCCESS,
    FETCH_ALL_REGISTERD_USERS_FAILURE,
    USER_UPDATE_REQUEST,
    USER_UPDATE_SUCCESS,
    USER_UPDATE_FAILURE,
    CHANGE_PASSWORD_REQUEST,
    CHANGE_PASSWORD_SUCCESS,
    CHANGE_PASSWORD_FAILURE,

} from '../actions/userAction';

const initialState = {
    privileges: [],
    loading: false,
    user: JSON.parse(localStorage.getItem('user')) || {},
    users: [],
    userRoles: [],
    usersByRole: {},
    token: localStorage.getItem('AuthToken') || null,
    isAuthenticated: Boolean(localStorage.getItem('AuthToken')),
    role: localStorage.getItem('user_role') || null,
    error: null,
    message: null,
    passwordChanged: false,
    userRegistered: false,
    needs2FA: false,
    twoFactorEmail: null
};

 const userReducer = (state = initialState, action) => {
    switch (action.type) {
        // Common loading state for all requests
        case USER_LOGIN_REQUEST:
        case USER_REGISTER_REQUEST:
        case USER_ROLES_REQUEST:
        case USERS_BY_ROLES_REQUEST:
        case FETCH_ALL_REGISTERD_USERS_REQUEST:
        case USER_UPDATE_REQUEST:
        case CHANGE_PASSWORD_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
                message: null
            };

        // Authentication cases
        case USER_LOGIN_SUCCESS:
            return {
                ...state,
                loading: false,
                user: action.payload.user,
                token: action.payload.token,
                isAuthenticated: true,
                role: action.payload.user.role,
                needs2FA: false,
                twoFactorEmail: null,
                error: null
            };

        case USER_REGISTER_SUCCESS:
            return {
                ...state,
                loading: false,
                user: action.payload,
                userRegistered: true,
                error: null
            };

        case USER_LOGIN_FAILURE:
        case USER_REGISTER_FAILURE:
            return {
                ...state,
                loading: false,
                user: {},
                token: null,
                isAuthenticated: false,
                error: action.payload?.message || action.payload || 'An error occurred'
            };

        case USER_LOGIN_FAILURE_TESTING:
            return {
                ...state,
                loading: false,
                error: action.payload?.message || action.payload || 'An error occurred'
            };

        case USER_LOGIN_2FA_REQUIRED:
            return {
                ...state,
                loading: false,
                isAuthenticated: false,
                needs2FA: true,
                twoFactorEmail: action.payload?.email,
                error: null
            };

        // User roles cases
        case USER_ROLES_SUCCESS:
            return {
                ...state,
                loading: false,
                userRoles: action.payload,
                error: null
            };

        case USER_ROLES_FAILURE:
            return {
                ...state,
                loading: false,
                userRoles: [],
                error: action.payload?.message || action.payload || 'Failed to fetch user roles'
            };

        // Users by role cases
        case USERS_BY_ROLES_SUCCESS:
            return {
                ...state,
                loading: false,
                usersByRole: action.payload,
                error: null
            };

        case USERS_BY_ROLES_FAILURE:
            return {
                ...state,
                loading: false,
                usersByRole: {},
                error: action.payload?.message || action.payload || 'Failed to fetch users by role'
            };

        // All registered users cases
        case FETCH_ALL_REGISTERD_USERS_SUCCESS:
            return {
                ...state,
                loading: false,
                users: action.payload,
                error: null
            };

        case FETCH_ALL_REGISTERD_USERS_FAILURE:
            return {
                ...state,
                loading: false,
                users: [],
                error: action.payload?.message || action.payload || 'Failed to fetch registered users'
            };

        // User update cases
        case USER_UPDATE_SUCCESS:
            return {
                ...state,
                loading: false,
                user: action.payload,
                error: null
            };

        case USER_UPDATE_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload?.message || action.payload || 'Failed to update user'
            };

        // Password change cases
        case CHANGE_PASSWORD_SUCCESS:
            return {
                ...state,
                loading: false,
                passwordChanged: true,
                message: action.payload,
                error: null
            };

        case CHANGE_PASSWORD_FAILURE:
            return {
                ...state,
                loading: false,
                passwordChanged: false,
                error: action.payload?.message || action.payload || 'Failed to change password'
            };

        case 'FETCH_PRIVILEGES_REQUEST':
            return { ...state, loading: true, error: null };

        case 'FETCH_PRIVILEGES_SUCCESS':
            return { ...state, loading: false, privileges: action.payload, error: null };

        case 'FETCH_PRIVILEGES_FAILURE':
            return { ...state, loading: false, error: action.payload?.message || action.payload || 'Failed to fetch privileges' };

        case 'CREATE_PRIVILEGE_REQUEST':
            return { ...state, loading: true, error: null };

        case 'CREATE_PRIVILEGE_SUCCESS':
            return {
                ...state,
                loading: false,
                privileges: [...state.privileges, action.payload],
                error: null,
            };

        case 'CREATE_PRIVILEGE_FAILURE':
            return { ...state, loading: false, error: action.payload?.message || action.payload || 'Failed to create privilege' };

        case 'UPDATE_PRIVILEGE_REQUEST':
            return { ...state, loading: true, error: null };

        case 'UPDATE_PRIVILEGE_SUCCESS':
            return {
                ...state,
                loading: false,
                privileges: state.privileges.map((priv) =>
                    priv.id === action.payload.id ? action.payload : priv
                ),
                error: null,
            };

        case 'UPDATE_PRIVILEGE_FAILURE':
            return { ...state, loading: false, error: action.payload?.message || action.payload || 'Failed to update privilege' };

        case 'DELETE_PRIVILEGE_REQUEST':
            return { ...state, loading: true, error: null };

        case 'DELETE_PRIVILEGE_SUCCESS':
            return {
                ...state,
                loading: false,
                privileges: state.privileges.filter((priv) => priv.id !== action.payload.id),
                error: null,
            };

        case 'DELETE_PRIVILEGE_FAILURE':
            return { ...state, loading: false, error: action.payload?.message || action.payload || 'Failed to delete privilege' };

        default:
            return state;
    }
};

export default userReducer;


// // Privilages Management Component
// export const privilegesReducer = (state = initialState, action) => {
//     switch (action.type) {
//         case 'FETCH_PRIVILEGES_REQUEST':
//             return { ...state, loading: true, error: null };

//         case 'FETCH_PRIVILEGES_SUCCESS':
//             return { ...state, loading: false, privileges: action.payload, error: null };

//         case 'FETCH_PRIVILEGES_FAILURE':
//             return { ...state, loading: false, error: action.payload };

//         case 'CREATE_PRIVILEGE_REQUEST':
//             return { ...state, loading: true, error: null };

//         case 'CREATE_PRIVILEGE_SUCCESS':
//             return {
//                 ...state,
//                 loading: false,
//                 privileges: [...state.privileges, action.payload],
//                 error: null,
//             };

//         case 'CREATE_PRIVILEGE_FAILURE':
//             return { ...state, loading: false, error: action.payload };

//         case 'UPDATE_PRIVILEGE_REQUEST':
//             return { ...state, loading: true, error: null };

//         case 'UPDATE_PRIVILEGE_SUCCESS':
//             return {
//                 ...state,
//                 loading: false,
//                 privileges: state.privileges.map((priv) =>
//                     priv.id === action.payload.id ? action.payload : priv
//                 ),
//                 error: null,
//             };

//         case 'UPDATE_PRIVILEGE_FAILURE':
//             return { ...state, loading: false, error: action.payload };

//         case 'DELETE_PRIVILEGE_REQUEST':
//             return { ...state, loading: true, error: null };

//         case 'DELETE_PRIVILEGE_SUCCESS':
//             return {
//                 ...state,
//                 loading: false,
//                 privileges: state.privileges.filter((priv) => priv.id !== action.payload.id),
//                 error: null,
//             };

//         case 'DELETE_PRIVILEGE_FAILURE':
//             return { ...state, loading: false, error: action.payload };

//         default:
//             return state;
//     }
// };

